<template>
  <header v-if="trad">
    <img @click="backHome" :src="trad.header.logo" alt="Logo liveConsent" /><br />
  </header>
</template>

<script>


export default {
  name: "Header",
  props: ["demoProgression","langTxt"],
  data() {
    return {
      trad: this.langTxt
    }
  },
  methods: {
    backHome() {
      document.location.href = this.trad.header.urlLogo;
    },
  },
};
</script>

<style scoped>
header {
  text-align: center;
  padding: 10px;
}
.mail,
.user {
  width: 40px;
  color: #657fa5;
}
img {
  cursor: pointer;
  /* !dm @ 20210106 */
  width: 200px;
}
</style>
